'use client';

import { T } from '@/i18n/LocaleProvider';
import { CONSENT_OPEN_EVENT } from '@/libs/consent';

/* Hoja cliente mínima: reabre el panel de ConsentManager desde el footer. */
export default function CookiePrefsLink({ className }) {
  return (
    <button
      type="button"
      className={className}
      onClick={() => window.dispatchEvent(new Event(CONSENT_OPEN_EVENT))}
    >
      <T>PREFERENCIAS DE COOKIES</T>
    </button>
  );
}
